import React from "react";
import Console from "../../assets/Services/Poker_Game_Dev/Raiden's_Universal/Console.svg"
import Mobile from "../../assets/Services/Poker_Game_Dev/Raiden's_Universal/Mobile.svg"
import PC from "../../assets/Services/Poker_Game_Dev/Raiden's_Universal/PC.svg"
import Tablet from "../../assets/Services/Poker_Game_Dev/Raiden's_Universal/Tablet.svg"

  const card = [
    {
      icon: Mobile ,
      title: "MOBILE",
    },
    {
      icon: PC ,
      title: "PC ",
    },
    {
      icon: Tablet ,
      title: "TABLET ",
    },
    {
      icon: Console ,
      title: "CONSOLE",
    },
  ]
const CoreComponent37 = () => {
  return (
    <div>
      <div className="row">
        {card.map((val, i) => (
          <div key={i} className="col-lg-3 col-6 d-flex flex-column mt-3 mb-3 mt-md-0 justify-content-center align-items-center">
            <div className="">

            </div>
            <div 
              className="p-4  rounded-4 "
              style={{ height: 100, width: 100 }}
            >
              <img
                src={val.icon}
                alt=""
                className="mt-2 mx-auto"
                style={{ width: 50, height: 50 }}
              />
            </div>
            <h3 className="h3-heading fw-bold fs-5 pt-2 mt-2  text-center">
              {val.title}
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoreComponent37;
